import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { LOGO_URL } from "@/lib/assets";

function Loading() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background" data-testid="auth-loading">
      <img src={LOGO_URL} alt="" className="h-14 w-14 object-contain animate-pulse" />
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
